import { ChevronRightIcon } from '@chakra-ui/icons';
import {
  Box,
  BoxProps,
  LinkBox,
  LinkOverlay,
  Spacer,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import React from 'react';

import { isExternalLink } from '../../../utils/link.utils';
import Link from '../../Link';
import { H4, Text } from '../../Text';

export interface TermCardProps extends BoxProps {
  heading: React.ReactNode | React.ReactNode[];
  details: string | React.ReactElement;
  href: string;
}

const TermCard: React.FC<TermCardProps> = ({
  heading,
  details,
  href,
  ...rest
}) => {
  const styles = useMultiStyleConfig('TermCard', {});
  return (
    <LinkBox as={Box} sx={styles.container} {...rest}>
      <LinkOverlay
        as={Link}
        to={href}
        aria-label={heading}
        variant="plain"
        isExternal={isExternalLink(href)}
      />
      <Box __css={styles.header}>
        <H4>{heading}</H4>
      </Box>
      <Box __css={styles.content}>
        {typeof details === 'string' ? (
          <Text marginBottom="1rem">{details}</Text>
        ) : (
          details
        )}
        <Spacer />
        <ChevronRightIcon sx={styles.control} />
      </Box>
    </LinkBox>
  );
};

export default TermCard;
